<div>
  <div bsModal #assignVendorModal="bs-modal" class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Assign Vendor</h4>
        </div>
        <div class="modal-body">
          <form [formGroup]="assignVendorForm">
            <div class="form-group">
              <label for="vendor">Assign to vendor</label>
              <ng-select
                [items]="vendors"
                bindLabel="name"
                [loading]="vendorLoading"
                [trackByFn]="vendorTrackByFn"
                (change)="onVendorSelect($event)"
                (clear)="clearVendor()"
                formControlName="vendor"
                [ngClass]="getValidationClass('vendor')">
                <ng-template ng-footer-tmp>
                  <a *ngIf="!vendorViewMoreClicked" (click)="loadAllVendors(false)" class="view-more-link">View more</a>
                </ng-template>
              </ng-select>
              <p class="text-danger" *ngIf="vendorMismatch">
                No Inspectors for this Vendor match the inspection’s product type. Proceed anyway?
              </p>
            </div>

            <div class="form-group">
              <label for="inspector">Assign to inspector</label>
              <ng-select
                [items]="inspectors"
                bindLabel="name"
                [loading]="inspectorLoading"
                [trackByFn]="inspectorTrackByFn"
                (change)="onInspectorSelect($event)"
                (clear)="clearInspector()"
                formControlName="inspector"
                [ngClass]="getValidationClass('inspector')"
                (close)="resetInspectors()">
                <ng-template ng-option-tmp let-item="item">
                  <div class="d-flex justify-content-between">
                    <span>
                      {{ item.name }}
                      <small *ngIf="item.distanceInMiles"> ({{ item.distanceInMiles }})</small>
                    </span>
                    <span class="d-flex align-items-center" style="width: 32%; justify-content: space-between">
                      <small class="pr-4 pb-1" *ngIf="item.distanceInMiles"
                        >Open Inspections: {{ item.assignmentMadeCount }}</small
                      >

                      <span class="star-container" [attr.data-tooltip]="item.rating + ' / 10'">
                        <ngx-stars
                          class="blue-stars"
                          [maxStars]="5"
                          [initialStars]="item.rating / 2"
                          color="#2763cd"
                          [readonly]="true"></ngx-stars>
                        <small> &nbsp;({{ item.inspectionRatingCount }})</small>
                      </span></span
                    >
                  </div>
                </ng-template>

                <ng-template ng-label-tmp let-item="item">
                  <div>
                    {{ item.name }}
                    <small *ngIf="item.distanceInMiles"> ({{ item.distanceInMiles }})</small>
                  </div>
                </ng-template>

                <ng-template ng-footer-tmp>
                  <a *ngIf="!viewMoreClicked" (click)="viewMoreInspectors()" class="view-more-link">View more</a>
                </ng-template>
              </ng-select>
              <p class="text-danger" *ngIf="inspectorMismatch">
                This Inspector doesn’t match the inspection’s product type. Proceed anyway?
              </p>
            </div>
          </form>
          <br />

          <div style="text-align: right">
            <button type="button" class="btn aru btn-secondary" (click)="cancel()">Close</button>
            <button type="button" [disabled]="!assignVendorForm.valid" class="btn aru btn-primary" (click)="save()">
              Save changes
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
